import cuid from "cuid";
import { uploadPhotoToCloudinary } from "../helper-methods";

export class UploadQueueManager {
  static uploadQueue = [];

  static addMediaToQueue = (media, mediaType, isForStory = false) => {
    const uploadId = cuid();
    // Add to queue
    const mediaToUpload = {
      data: { media, mediaType, isForStory },
      uploadId,
    };
    UploadQueueManager.uploadQueue.push(mediaToUpload);
    // Start upload process
    UploadQueueManager.startUploadProcess(mediaToUpload);
    // Return back uploadId
    EventEmitter.dispatch(
      "upload-queue-count-change",
      UploadQueueManager.uploadQueue.length
    );
    return uploadId;
  };

  static startUploadProcess = async (media) => {
    try {
      const uploadLink = await UploadQueueManager.uploadMedia(
        media.data.media,
        media.data.mediaType,
        media.data.isForStory
      );
      EventEmitter.dispatch(`upload-complete-for-${media.uploadId}`, {
        ...media,
        fileUrl: uploadLink,
      });
      // Remove media from queue
      UploadQueueManager.removeFromQueue(media.uploadId);
      // Emit queue count change event
      EventEmitter.dispatch(
        "upload-queue-count-change",
        UploadQueueManager.uploadQueue.length
      );
    } catch (error) {
      console.log("error>>", error);
    }
  };

  static onCompleteUploadProcess = (callback) => {
    EventEmitter.subscribe("complete-upload-process", callback);
    // EventEmitter.unsubscribe("complete-upload-process");
  };

  static onUploadComplete = (uploadId, callback) => {
    // Emit complete event
    EventEmitter.subscribe(`upload-complete-for-${uploadId}`, callback);
  };

  static onQueueCountChange = (callback) => {
    EventEmitter.subscribe("upload-queue-count-change", callback);
  };

  static removeFromQueue = (uploadId) => {
    const indexOfMedia = UploadQueueManager.uploadQueue.findIndex(
      (media) => media.uploadId === uploadId
    );
    UploadQueueManager.uploadQueue.splice(indexOfMedia, 1);
    if (
      !UploadQueueManager.uploadQueue ||
      !UploadQueueManager.uploadQueue.length
    ) {
      EventEmitter.dispatch("complete-upload-process");
      // setTimeout(() => {
      //   EventEmitter.events = {};
      // }, 500);
    }
  };

  static uploadMedia = (media, mediaType, isForStory = false) => {
    return new Promise(async (resolve, reject) => {
      switch (mediaType) {
        case "image": {
          const imageUrl = await uploadPhotoToCloudinary({
            isForStory,
            photo: media.file,
            type: "blob",
          });
          resolve(imageUrl);
          break;
        }
        case "video": {
          const videoUrl = await uploadPhotoToCloudinary({
            isForStory,
            photo: media.blobObject,
            type: "blob",
            fileName: null,
            fileType: "video",
          });
          resolve(videoUrl);
          break;
        }
        case "audio": {
          const audioUrl = await uploadPhotoToCloudinary({
            isForStory,
            photo: media.blobObject.blob,
            type: "blob",
            fileName: null,
            fileType: "audio",
          });
          resolve(audioUrl);
          break;
        }
        case "doc": {
          const docUrl = await uploadPhotoToCloudinary({
            isForStory,
            photo: media.file,
            type: "blob",
            fileName: null,
            fileType: "doc",
          });
          resolve(docUrl);
          break;
        }
        default:
          reject({
            error: true,
            reason: "Something went wrong, Try again after sometime.",
          });
      }
    });
  };
}

/**
 * To communicate through events
 */
const EventEmitter = {
  events: {},
  dispatch: function (event, data = null) {
    // Check if the specified event is exist / subscribed by anyone
    if (!this.events[event]) {
      // Doesn't exist, so just return
      return;
    } else {
      // Exists
      // Process all bound callbacks
      this.events[event].forEach((callback) => callback(data));
    }
  },
  subscribe: function (event, callback) {
    // Check if the specified event is exist / subscribed by anyone
    if (!this.events[event]) {
      // Not subscribed yet, so make it an array so that further callbacks can be pushed
      this.events[event] = [];
    }
    // Push the current callback
    this.events[event].push(callback);
  },
};
